export const ACCOUNTS_TRANSLATE = {
    accounts: {
        breadcrumbName: "Accounts",
        messages: {
            create: "Account created successfully",
            update: "Account updated successfully",
            delete: "Account deactivated successfully",
            recover: "Account restored successfully"
        },
        list: {
            filters: {
                fields: {
                    id: {
                        label: "ID",
                        placeholder: "Enter the ID",
                        url: "id"
                    },
                    name: {
                        label: "Name",
                        placeholder: "Enter the name",
                        url: "name"
                    },
                    email: {
                        label: "Email",
                        placeholder: "Enter the email",
                        url: "email"
                    },
                    active: {
                        label: "Status",
                        placeholder: "Select the status",
                        url: "status"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Deactivate Account",
                    body: "Are you sure you want to deactivate the account with ID {{id}}",
                    save: {
                        text: "Yes, deactivate"
                    },
                    back: {
                        text: "Back"
                    },
                }
            },
            table: {
                columns: {
                    id: "ID",
                    name: "Name"
                }
            }
        },
        tabs: {
            general: "General",
            text: "Texts",
            users: "Users",
            asks: "Questions",
            logo: "Logo",
            languages: "Languages"
        },
        dictionaries: {
            breadcrumb: "Dictionaries",
            messages: {
                create: "Dictionary created successfully",
                update: "Dictionary updated successfully",
                delete: "Dictionary removed successfully",
                recover: "Dictionary restored successfully"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        language: "Language"
                    }
                },
                dialog: {
                    delete: {
                        title: "Remove dictionary",
                        body: "Are you sure you want to remove the dictionary with ID {{id}}?",
                        save: {
                            text: "Yes, remove"
                        },
                        back: {
                            text: "Back"
                        }
                    }
                }
            },
            save: {
                form: {
                    fields: {
                        languageId: {
                            label: "Language",
                            placeholder: "Select the language"
                        },
                        welcomeMessage: {
                            label: "Welcome Message",
                            placeholder: "Enter the welcome message here"
                        },
                        welcomeTerms: {
                            label: "Terms of Use",
                            placeholder: "Enter the terms of use here"
                        },
                        choiceHelpText: {
                            label: "Message for the \"Don't know which to choose?\" button",
                            placeholder: "Enter the message here"
                        },
                        helpText: {
                            label: "Message for the \"Help\" button",
                            placeholder: "Enter the message here"
                        }
                    }
                }
            }
        },

        save: {
            form: {
                fields: {
                    name: {
                        label: "Name",
                        placeholder: "Enter the name here"
                    },
                    uuid: {
                        label: "UUID",
                        placeholder: "Enter the account UUID here"
                    },
                    welcomeTerms: {
                        label: "Terms of Use",
                        placeholder: "Enter the terms of use here"
                    },
                    welcomeMessage: {
                        label: "Welcome Message",
                        placeholder: "Enter the welcome message here"
                    },
                    choiceHelpText: {
                        label: "Message for the \"Don't know which to choose?\" button",
                        placeholder: "Enter the message here"
                    },
                    helpText: {
                        label: "Message for the \"Help\" button",
                        placeholder: "Enter the message here"
                    },
                    generalChannelUrl: {
                        label: "Complaint URL",
                        placeholder: "Enter the complaint URL here"
                    },
                    womenChannelUrl: {
                        label: "Women's Channel URL",
                        placeholder: "Enter the women's channel URL here"
                    },
                    showGeneralChannel: {
                        label: "Show General Channel"
                    },
                    showWomenChannel: {
                        label: "Show Women's Channel"
                    },
                    categoryIsOptional: {
                        label: "Optional Category",
                        placeholder: "While this option is checked, the complainant is not required to provide a category"
                    },
                    multipleLanguagesEnabled: {
                        label: "Allow collaborator to select language",
                        placeholder: "If this setting is enabled, a language selection button will be visible in the top corner of the screen"
                    },
                    logo: {
                        label: "Logo",
                        noResultsLabel: "No image added",
                        noResultsDescription: "",
                        textButton: "Add logo",
                        changeTextButton: "Change logo",
                        hints: {
                            first: "The ideal proportion for the logo is 1500 x 700 (width x height)",
                            second: "Accepted formats: .JPG, .JPEG, .PNG, .WEBP, .GIF"
                        }
                    }
                }
            }
        },

        languages: {
            messages: {
                activate: "Language activated successfully",
                inactivate: "Language deactivated successfully"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        name: "Name",
                        tag: "Tag"
                    }
                },
                dialog: {
                    activate: {
                        title: "Activate language",
                        body: "Are you sure you want to activate the language \"{{name}}\"?",
                        save: {
                            text: "Yes, activate"
                        },
                        back: {
                            text: "Back"
                        }
                    },
                    inactivate: {
                        title: "Deactivate language",
                        body: "Are you sure you want to deactivate the language \"{{name}}\"?",
                        save: {
                            text: "Yes, deactivate"
                        },
                        back: {
                            text: "Back"
                        }
                    }
                }
            }
        },

        asks: {
            messages: {
                create: "Question added successfully",
                update: "Question updated successfully",
                delete: "Question deleted successfully",
                recover: "Question restored successfully"
            },
            list: {
                dialog: {
                    delete: {
                        title: "Remove Question",
                        body: "Are you sure you want to remove the question with ID {{id}}",
                        save: {
                            text: "Yes, remove"
                        },
                        back: {
                            text: "Back"
                        },
                    }
                },
                listActions: {
                    options: {
                        text: "Answer Options"
                    },
                    dictionaries: {
                        text: "See dictionary"
                    }
                },
                columns: {
                    title: "Title",
                    id: "ID",
                    required: "Required"
                }
            },
            create: {
                title: "Add Question"
            },
            update: {
                title: "Edit Question"
            },
            fields: {
                title: {
                    label: "Field Name",
                    placeholder: "Enter the field name here"
                },
                required: {
                    label: "Required Field"
                }
            },
            dictionaries: {
                dialog: {
                    title: "Question Dictionaries"
                },
                messages: {
                    create: "Dictionary created successfully",
                    update: "Dictionary updated successfully",
                    delete: "Dictionary removed successfully",
                    recover: "Dictionary restored successfully"
                },
                create: {
                    title: "Add dictionary"
                },
                update: {
                    title: "Edit dictionary"
                },
                list: {
                    label: "Dictionaries",
                    columns: {
                        id: "ID",
                        language: "Language",
                        title: "Title"
                    },
                    dialog: {
                        delete: {
                            title: "Remove dictionary",
                            body: "Are you sure you want to remove the dictionary with ID {{id}}",
                            save: {
                                text: "Yes, remove"
                            },
                            back: {
                                text: "Back"
                            }
                        }
                    }
                },
                save: {
                    form: {
                        fields: {
                            languageId: {
                                label: "Language",
                                placeholder: "Select a language"
                            },
                            title: {
                                label: "Question title",
                                placeholder: "Enter the question title in this language"
                            }
                        }
                    }
                }
            },

            options: {
                messages: {
                    create: "Option added successfully",
                    update: "Option updated successfully",
                    delete: "Option deleted successfully",
                    recover: "Option restored successfully"
                },
                create: {
                    title: "Add Option"
                },
                update: {
                    title: "Edit Option"
                },
                fields: {
                    title: {
                        label: "Option Title",
                        placeholder: "Enter the option title here"
                    }
                },
                list: {
                    label: "Options",
                    columns: {
                        id: "ID",
                        title: "Title"
                    },
                    dialog: {
                        delete: {
                            title: "Remove Option",
                            body: "Are you sure you want to remove the option with ID {{id}}",
                            save: {
                                text: "Yes, remove"
                            },
                            back: {
                                text: "Back"
                            },
                        }
                    },
                    listActions: {
                        dictionaries: {
                            text: "See dictionary"
                        }
                    }
                },
                save: {
                    fields: {
                        title: {
                            label: "Title",
                            placeholder: "Enter the option title here"
                        }
                    }
                },
                dictionaries: {
                    dialog: {
                        title: "Option Dictionaries"
                    },
                    messages: {
                        create: "Dictionary created successfully",
                        update: "Dictionary updated successfully",
                        delete: "Dictionary removed successfully",
                        recover: "Dictionary restored successfully"
                    },
                    create: {
                        title: "Add dictionary"
                    },
                    update: {
                        title: "Edit dictionary"
                    },
                    list: {
                        label: "Dictionaries",
                        columns: {
                            id: "ID",
                            language: "Language",
                            title: "Title"
                        },
                        dialog: {
                            delete: {
                                title: "Remove dictionary",
                                body: "Are you sure you want to remove the dictionary with ID {{id}}?",
                                save: {
                                    text: "Yes, remove"
                                },
                                back: {
                                    text: "Back"
                                }
                            }
                        }
                    },
                    save: {
                        form: {
                            fields: {
                                languageId: {
                                    label: "Language",
                                    placeholder: "Select a language"
                                },
                                title: {
                                    label: "Option title",
                                    placeholder: "Enter the option title in this language"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
